<!--  -->
<template>
  <div>
    <div class="cooperation-wrap content-main" v-if="!subType">
      <div class="item-left animate__animated animate__zoomIn">
        <img
          src="../../assets/image/meeting_item1.png"
          alt=""
          class="item-img"
          @click="showSubPage('inter')"
        />
      </div>
      <div class="item-right cooperation-item">
        <img
          src="../../assets/image/meeting_item2.png"
          alt=""
          class="animate__animated animate__zoomIn item-img"
          @click="showSubPage('visit')"
        />
        <img
          src="../../assets/image/meeting_item3.png"
          alt=""
          class="animate__animated animate__zoomIn item-img"
          @click="showSubPage('sign')"
        />
      </div>
    </div>
    <ul class="sub-nav"  v-else>
      <li class="sub-nav-item" v-for="item in subList" :key="item.type" @click="showSubPage(item.type)"
        :class="{ cu: subType === item.type }">
        {{ item.title }}
      </li>
    </ul>
    <meeting-timeline v-if="subType === 'inter'"></meeting-timeline>
<!--    <meeting-timeline v-if="subType === 'visit'"></meeting-timeline>-->
    <div class="content-main" v-if="subType === 'sign'">
       <meeting-sign></meeting-sign>
    </div>
  </div>
</template>

<script>
import meetingTimeline from "./meeting_timeline.vue";
import meetingSign from "./meeting_sign.vue";
export default {
  data() {
    return {
        subType: 'inter',
        subList: [
            {type:'inter',title: '海外交流'},
            // {type:'visit',title: '访问交流'},
            {type:'sign',title: '签约'}
        ]
    };
  },
  created(){
      this.subType = this.$route.query.subType
  },
  components: {
      meetingTimeline,
      meetingSign
  },
  methods: {
      showSubPage(type){
          this.$router.push({
              path: '/detail',
              query:{
                  type: 'cooperation',
                  subType: type
              }
          })
      }
  },
};
</script>
<style lang='scss' scoped>
.cooperation-wrap {
  display: flex;
  justify-content: space-between;
  font-size: 0;
  .item-img {
    cursor: pointer;
    &:hover {
      box-shadow: 6px 6px 6px #ccc;
    }
  }
  .item-left {
    width: 423px;
    img {
      height: 600px;
    }
  }
  .item-right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    img {
      height: 280px;
    }
  }
}
  .sub-nav {
    display: flex;
    flex-wrap: nowrap;
    text-align: center;
    line-height: 48px;
    margin: 20px auto;
    width: 1200px;
    .sub-nav-item {
      width: 200px;
      background: #f5f7fa;
      margin-right: 10px;
      cursor: pointer;

      &.cu {
        background: #66b1ff;
        color: #fff;
      }

      &:not(.cu):hover {
        background: #66b1ff;
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/components/cooperation.vue